/* eslint-disable max-classes-per-file, lines-between-class-members */
/* errors in this file can be thrown during render to trigger the ErrorBoundary */

import { ERROR_ACTION, ERROR_PAGE_BUTTONS } from 'constants/error';

type ErrorBoundaryErrorDetails = {
  coverTitle?: string;
  title?: string;
  confirmLabel?: string;
  message?: string;
  subtitle?: string;
  buttonCta?: (typeof ERROR_PAGE_BUTTONS)[keyof typeof ERROR_PAGE_BUTTONS];
};

// @todo move to a central location or types file
type ErrorBoundaryData = {
  hasError: true;
  errorAction: string;
  errorDetails?: ErrorBoundaryErrorDetails;
};

/**
 * generic error boundary error supporting all error actions
 * @usage `throw new ErrorBoundaryError({ hasError: true, errorAction: ... })`
 */
export class ErrorBoundaryError extends Error {
  constructor(public errorBoundaryData: ErrorBoundaryData) {
    super();

    this.errorBoundaryData = { ...errorBoundaryData, hasError: true };
  }
}

/**
 * convenience wrapper specifically for the `SHOW_UNAUTHORIZED_ERROR` errorAction
 * @usage `throw new ErrorBoundaryUnauthorizedError()`
 */
export class ErrorBoundaryUnauthorizedError extends ErrorBoundaryError {
  /** @deprecated use `new ErrorBoundaryUnauthorizedError({ coverTitle })` */
  constructor(errorDetailsOrCoverTitle: string);
  constructor(errorDetailsOrCoverTitle: ErrorBoundaryErrorDetails);
  constructor(errorDetailsOrCoverTitle: ErrorBoundaryErrorDetails | string) {
    super({
      errorAction: ERROR_ACTION.SHOW_UNAUTHORIZED_ERROR,
      hasError: true,
      errorDetails:
        typeof errorDetailsOrCoverTitle === 'string'
          ? { coverTitle: errorDetailsOrCoverTitle }
          : errorDetailsOrCoverTitle,
    });
  }
}
